import { FOOTER } from "../../../util/brand";

function FooterMain() {
  return (
    <footer className="border-t border-gray-200">
      <div className="max-w-7xl mx-auto flex justify-between items-center flex-wrap gap-4 p-5">
        {FOOTER.stripped ? (
          <div className="footer-copyright">
            © 2025 {FOOTER.owner} · <a href={`mailto:${FOOTER.email}`}>{FOOTER.email}</a>
          </div>
        ) : (
          <>
            <div className="footer-copyright">
              © 2025 {FOOTER.owner} - All Rights Reserved
            </div>
            <div className="footer-links flex gap-4">
              <a href="/privacy-policy">Privacy Policy</a>
              <a href="/terms-of-service">Terms of Service</a>
            </div>
          </>
        )}
      </div>
    </footer>
  );
}

export default FooterMain;
